import { useTranslations } from '@vocab/react';
import { Actions, Button, Stack, Text } from 'braid-design-system';

import { TrackOnMount } from 'src/libs/Analytics';

import translations from './.vocab';

export const ErrorDialogContent = ({
  onClose,
  isFailToGetPlacementStatusError,
  trackErrorDialogDisplayed,
}: {
  open: boolean;
  onClose: () => void;
  isFailToGetPlacementStatusError?: boolean;
  trackErrorDialogDisplayed: () => void;
}) => {
  const { t } = useTranslations(translations);
  return (
    <TrackOnMount onMount={() => trackErrorDialogDisplayed()}>
      <Stack space="large" align="center">
        <Text>
          {t(
            isFailToGetPlacementStatusError
              ? 'Please refresh the page or try updating the status later.'
              : 'Please refresh the page or try again later.',
          )}
        </Text>
        <Actions>
          <Button onClick={onClose} tone="brandAccent">
            {t('Close')}
          </Button>
        </Actions>
      </Stack>
    </TrackOnMount>
  );
};
